// extracted by mini-css-extract-plugin
export default {"container":"gif_container__jUih2","playGif":"gif_playGif__9xdTj","gif":"gif_gif__djWSy","credit":"gif_credit__jO-F4"};